export default __webpack_public_path__ + "static/media/Prologue_Kyo1.01c821ce.png";